// Centralized public-facing site configuration. Read from build-time env vars
// so support/privacy inboxes can be rotated without code changes.
// Defaults assume the live `@zcars.ai` brand. Override via frontend/.env.
export const SITE_EMAILS = {
  support: process.env.REACT_APP_SUPPORT_EMAIL || "support@zcars.ai",
  // legal routes to support — do not create a separate legal@zcars.ai inbox
  legal: process.env.REACT_APP_SUPPORT_EMAIL || "support@zcars.ai",
  privacy: process.env.REACT_APP_PRIVACY_EMAIL || "privacy@zcars.ai",
};

/** External social profiles. Override via REACT_APP_SOCIAL_* if needed. */
export const SITE_SOCIALS = [
  {
    id: "facebook",
    label: "Facebook",
    href: process.env.REACT_APP_SOCIAL_FACEBOOK || "https://www.facebook.com/z.cars.rentals",
  },
  {
    id: "twitter",
    label: "X (Twitter)",
    href: process.env.REACT_APP_SOCIAL_TWITTER || "https://x.com/z_cars_ca",
  },
  {
    id: "instagram",
    label: "Instagram",
    href: process.env.REACT_APP_SOCIAL_INSTAGRAM || "https://www.instagram.com/z_cars_rentals/",
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    href: process.env.REACT_APP_SOCIAL_LINKEDIN || "https://www.linkedin.com/company/zcars/",
  },
].filter((item) => typeof item.href === "string" && /^https?:\/\//i.test(item.href.trim()));
